import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Header from "../components/Header";
import SubHeader from "../components/SubHeader";
import DashboardAdmin from "../components/DashboardComponents/DashboardAdmin";
import DashboardReader from "../components/DashboardComponents/DashboardReader";
import { useSelector } from "react-redux";

const Dashboard = ({}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.user?.redux_object || null);

  return (
    <>
      {user.user && user.user.role === "admin" ? (
        <DashboardAdmin />
      ) : (
        <DashboardReader />
      )}
    </>
  );
};

export default Dashboard;
